module.exports = __webpack_public_path__ + "img/logo-y-p.a29d22dd6e12789576f3193ef45494f2.svg";